import { apiRequest } from "../../index";

export const addActivity = async (activityData) => {
  return apiRequest("/api/owner/hotel-management/activities", "POST", activityData);
};

export const getActivitiesByHotelId = async ({page , limit , hotelId}) => {
  return apiRequest(`/api/owner/hotel-management/activities/${hotelId}?page=${page}&limit=${limit}`, "GET");
};

export const updateActivity = async (activityId, activityData) => {
  return apiRequest(`/api/owner/hotel-management/activities/${activityId}`, "PUT", activityData);
};

export const deleteActivity = async (activityId) => {
  return apiRequest(`/api/owner/hotel-management/activities/${activityId}`, "DELETE");
};
